import styled from 'styled-components'

// Note: The field chrome (border, background, height, states, error colors, label,
// footer, the leading calendar icon + divider and the clear/restore actions) all
// live in `TextInput`. This file only owns what `TextInput` can't provide: the
// calendar dropdown that floats below the field.

// Note: on mobile ($isMobile), floating-ui's positioning is skipped entirely (see
// date-picker-input.tsx - the middleware array is empty and no floatingStyles are applied), so
// this becomes a plain fixed full-screen sheet instead of an anchored popover.
export const FloatingWrapper = styled.div<{ $isMobile?: boolean }>(({ theme, $isMobile }) => ({
  zIndex: theme.zIndex.level3,

  ...($isMobile && {
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
  }),
}))

export const Dropdown = styled.div<{ $isMobile?: boolean }>(({ theme, $isMobile }) => ({
  background: theme.colors.white,
  border: $isMobile ? 'none' : `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: $isMobile ? 0 : theme.border.radius['8'],
  boxShadow: $isMobile ? 'none' : theme.shadow.lg,
  display: $isMobile ? 'flex' : 'block',
  flexDirection: $isMobile ? 'column' : undefined,
  height: $isMobile ? '100%' : undefined,
  maxWidth: $isMobile ? 'none' : 'fit-content',
  overflow: 'hidden',
  width: $isMobile ? '100%' : undefined,
}))

// Note: mobile-only header holding the close button - there's nothing to show it alongside
// (no title), so it's just a flex-end row rather than the title+icon split ModalHeader uses.
export const MobileHeader = styled.div(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'flex-end',
  padding: `${theme.space['12']} ${theme.space['16']}`,
}))

// Note: visually mirrors Modal's own ModalCloseButton (modal.styled.ts) - duplicated rather
// than imported since that export is private to modal.tsx, not a shared primitive.
export const CloseButton = styled.button(({ theme }) => ({
  '&:focus-visible': {
    outline: `2px solid ${theme.colors.blue500}`,
    outlineOffset: '2px',
  },

  '&:hover': {
    color: theme.colors.black800,
  },

  alignItems: 'center',
  background: 'transparent',
  border: 'none',
  borderRadius: theme.border.radius['4'],
  color: theme.colors.black600,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  transition: `color ${theme.transition.duration.sm}`,
}))

// Note: mobile-only scroll container for <DatePicker> - a tall calendar (e.g. a long
// year-select list) scrolls within the sheet instead of overflowing it.
export const DropdownBody = styled.div<{ $isMobile?: boolean }>(({ $isMobile }) => ({
  ...($isMobile && {
    flex: 1,
    overflowY: 'auto',
  }),
}))
